import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { ExecutionRecord, ExecutionRecordKind } from '@mprolab/sdk'
import { MarkdownBody } from 'views/Documentation/MarkdownBody'

const Wrapper = styled(Flex)`
  flex-direction: column;
  gap: 10px;
  padding: 14px 16px;
  border-radius: 10px;
  border: 1px solid ${({ theme }) => theme.colors.gray8};
  background: ${({ theme }) => theme.colors.background};
`

const KindPill = styled.span<{ $bg: string; $color: string }>`
  align-self: flex-start;
  padding: 3px 12px;
  border-radius: 999px;
  background: ${({ $bg }) => $bg};
  color: ${({ $color }) => $color};
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
`

interface DecisionRegistryRecordProps {
  record: ExecutionRecord
  kindLabel: string
}

const DecisionRegistryRecord: React.FC<DecisionRegistryRecordProps> = ({
  record,
  kindLabel
}) => {
  const { t } = useTranslation()
  const { colors } = useTheme()
  const recordedBy = `${record.recordedBy.slice(0, 8)}…${record.recordedBy.slice(-6)}`
  const recordedAt = dayjs(record.recordedAt).format('YYYY-MM-DD HH:mm UTC')

  const pillColors =
    record.executionKind === ExecutionRecordKind.ON_CHAIN
      ? { bg: `${colors.cyan}33`, color: colors.cyan }
      : record.executionKind === ExecutionRecordKind.OFF_CHAIN_ACTION
        ? { bg: `${colors.green}33`, color: colors.green }
        : { bg: colors.gray8, color: colors.gray6 }

  return (
    <Wrapper>
      <KindPill $bg={pillColors.bg} $color={pillColors.color}>
        {kindLabel}
      </KindPill>
      <Flex flexWrap="wrap" gap="14px">
        <Text variant={TextVariant.TEXT_XS_REGULAR} color={colors.gray6}>
          {t('dao.executionRecord.recordedAt', { date: recordedAt })}
        </Text>
        <Text variant={TextVariant.TEXT_XS_REGULAR} color={colors.gray6}>
          {t('dao.executionRecord.recordedBy', { wallet: recordedBy })}
        </Text>
        {record.txHash ? (
          <Text variant={TextVariant.TEXT_XS_REGULAR} color={colors.cyan}>
            {t('dao.executionRecord.txHash')}: {record.txHash}
          </Text>
        ) : null}
      </Flex>
      <MarkdownBody markdown={record.description} outline={[]} />
    </Wrapper>
  )
}

export default DecisionRegistryRecord
